<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.cnpj"
                        label="CNPJ"
                        placeholder="99.999.999/9999-99"
                        v-mask="mask.cnpj"
                        v-model="data.model.cnpj"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :validations="validations.inscricaoEstadual"
                        label="Inscrição estadual"
                        number
                        v-model="data.model.inscricaoEstadual"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nomeFantasia"
                        label="Nome fantasia"
                        uppercase
                        v-model="data.model.nomeFantasia"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.razaoSocial"
                        label="Razão social"
                        uppercase
                        v-model="data.model.razaoSocial"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                     <rkm-form-select
                        :options="data.form.categorias"
                        :validations="validations.categoria"
                        label="Categoria"
                        show-default-option
                        text-field="nome"
                        v-model="data.model.categoriaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.site"
                        label="Site"
                        v-model="data.model.site"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <Telefone
            :data="data"
            ref="Telefone"
        />
    </div>
</template>

<script>
// Components.
import Telefone from './components/telefone/Index'

// Mixins.
import { mask } from '@/mixins'

export default {
    components: { Telefone },
    computed: {
        validations() {

            return {
                cnpj: {
                    required: false,
                    min_max_without_mask: 14,
                    cnpj: true,
                },
                inscricaoEstadual: {
                    min: 8,
                    max: 14,
                },
                nomeFantasia: {
                    required: true,
                    min: 3,
                    max: 255,
                },
                razaoSocial: {
                    required: true,
                    min: 3,
                    max: 255,
                },
                categoria: {},
                site: {
                    max: 180,
                    url: true,
                },
            }
        },
    },
    methods: {
        async validate() {

            return await this.$refs.Form.validate()
                && await this.$refs.Telefone.validate()
        },
    },
    mixins: [ mask ],
    props: {
        data: { type: Object, required: true }
    },
}
</script>